export type SearchResult<T> = { term: string; users: T[] };

// A finished search that found no one stays empty, so the menu can say so instead of falling back to the defaults.
export const suggestionsFor = <T>(input: string, search: SearchResult<T> | null, defaults: T[]): T[] =>
  search && search.term === input.trim() ? search.users : defaults;
